import axios from "axios";
import { defineStore } from "pinia";
import environment from "@/environment";

const proxyStoreActions = {
  async getTags() {
    try {
      const result = await axios.get(this.endpoint + "/?page=1&limit=1000");
      this.tagList = result.data.results;
    } catch (e) {
      console.log(e);
    }
  },
  async updateTag(data) {
    const payload = {
      name: data.name,
      category: data.category
    };
    try {
      await axios.put(this.endpoint + `/${data.id}`, payload);
    } catch (e) {
      console.log(e);
    }
  },

  async createTag(data) {
    try {
      const payload = {
        name: data.name,
        category: data.category
      };
      const result = await axios.post("/tags/", payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      return result.data.id;
    } catch (e) {
      console.log(e);
      return false;
    }
  }
};

export const useTags = defineStore({
  id: "tags",
  state: () => ({
    tagList: [],
    currentProxy: null,
    endpoint: environment.getInternalTags,
  }),
  actions: {
    ...proxyStoreActions,
  },
});

export const tagsColumnList = [
  {
    id: "name",
    name: "Имя",
    width: "200px",
    isEdit: true,
  },
  {
    id: "category",
    name: "Категория",
    width: "200px",
    isEdit: true,
  },
  {
    id: "id",
    name: "id",
    width: "100px",
    isEdit: false,
  },
];